/* Response Time CSS */

export default theme => ({
    root: {},
    chart: {
      width: '500px',
      margin: '0 auto',
      //height: '300px',
      textAlign: 'center',
    },
    header: {
      height: '40px',
      color: theme.palette.text.secondary
    },
    portletFooter: {
      display: 'flex',
      justifyContent: 'space-between'
    },
    portletFooterTwo: {
      paddingLeft: theme.spacing(3),
      paddingRight: theme.spacing(3),
      paddingTop: theme.spacing(2),
      paddingBottom: theme.spacing(2)
    },
    backGrey:{
      backgroundColor:"#525252",
      //minWidth: '30vw'
    },
    backGrey2:{
      backgroundColor:"#5d5d5d",
      marginBottom: "0px !important",
      marginTop: "0px !important",
      padding: "10px"
    },
    backWhite:{
      backgroundColor:"white"
    },
    textWhite:{
      color:"white"
    },
    details: {
      padding: '50px',
      flex: '1 100%',
      marginTop: '50px',
      marginBottom: '50px',
      marginRight: '50px',
      marginLeft: '50px'
    },
    cells:{
      '&:sticky-table-cell':{
        borderLeft: '2px #e5e5e5',
        display: 'table-cell',
        backgroundColor:'red'
      },
      backgroundColor:'red'
    },
    modal: {
      maxHeight: '100%',
      maxWidth: '90vw',
      //position: 'relative',
      //top: '50%',
      
      transform: 'translate(0, 0)',
      overflowY: 'auto',
      //padding: theme.spacing(2, 4, 3),
      boxShadow: theme.shadows[5],
      /*[theme.breakpoints.between('sm', 'lg')]: {
        width: '75vw',
      },
      [theme.breakpoints.down('sm')]: {
        width: '100vw',
      },*/
    },
    form: {
      display: 'flex',
      flexWrap: 'wrap',
      width:'40%'
    },
    group: {
      flexGrow: 1,
      padding: theme.spacing(1)
    },
    textField: {
      width: '80%',
      marginBottom: theme.spacing(1),
      marginTop: theme.spacing(1)
    },
    snackContent: {
      backgroundColor: theme.palette.error.dark,
    },
    snackContentOk: {
      backgroundColor: theme.palette.success.main,
    },
    icon: {
      fontSize: 20,
    },
    iconVariant: {
      opacity: 0.9,
      marginRight: theme.spacing(2),
    },
    message: {
      display: 'flex',
      alignItems: 'center',
      fontSize: 20,
    },
    modalDeleted: {
      maxHeight: '100%',
      //position: 'relative',
      //top: '50%',
      transform: 'translate(0, 50%)',
      overflowY: 'auto',
      //padding: theme.spacing(2, 4, 3),
      boxShadow: theme.shadows[5],
      backgroundColor: 'white',
      border: '2px solid #000',
      //width: '75vw',
      /*[theme.breakpoints.between('sm', 'lg')]: {
        width: '75vw',
      },
      [theme.breakpoints.down('sm')]: {
        width: '100vw',
      },*/
    },
  });
  
  